import { GalaxyFilterChipsComponent } from './galaxy-filter-chips.component';
import { NgModule } from '@angular/core';

export const MODULE_IMPORTS = [GalaxyFilterChipsComponent];

export const MODULE_EXPORTS = [GalaxyFilterChipsComponent];

@NgModule({
  // This module uses standalone components - we just use the module to remain consistent
  declarations: [],
  imports: MODULE_IMPORTS,
  exports: MODULE_EXPORTS,
})
export class GalaxyFilterChipsModule {}
